import { type InferResponseType, unwrap } from "@nexxt/api-client";
import { filterQuery } from "@nexxt/app-kit";
import type { ListWaitingGatesInput } from "@nexxt/contracts/reference";
import { infiniteQueryOptions } from "@tanstack/react-query";
import { api } from "../../api";
import { gateQueries } from "./gate.queries";

// Server state of what waits for an approval (B-60, ADR-224): the gates open in every domain, served by reference.
// Under the key of the gates, so a change of a gate (its days, its roles) reads them again; a decision taken in a
// domain shows at the next read, as the count of the home does.

const waitingGates = api.reference["waiting-gates"];

type ListPage = InferResponseType<typeof waitingGates.$get, 200>;
export type WaitingGate = ListPage["items"][number];

/** The filters of the list input (`listWaitingGatesInput`), without the paging the query adds. */
export type WaitingGateFilters = Pick<ListWaitingGatesInput, "status">;

const PAGE_SIZE = 50;

const keys = { waiting: [...gateQueries.all, "waiting"] as const };

export const waitingGateQueries = {
  ...keys,

  /** The oldest request first. */
  list: (filters: WaitingGateFilters) =>
    infiniteQueryOptions({
      queryKey: [...keys.waiting, filters],
      queryFn: ({ pageParam, signal }) =>
        unwrap(
          waitingGates.$get(
            { query: { ...filterQuery(filters), page: String(pageParam), pageSize: String(PAGE_SIZE) } },
            { init: { signal } },
          ),
        ),
      initialPageParam: 1,
      getNextPageParam: (last) => (last.hasMore ? last.page + 1 : undefined),
    }),
};
